import { Button } from "@mui/material";
import { IReportsListActionProps } from "../types/interfaces/IReportsListActionProps";

//This component is responsible for viewing a report.
export function ReportsListAction({ report, onView }: IReportsListActionProps) {
    return (
        <Button
            variant="contained"
            size="medium"
            color="primary" 
            onClick={() => onView(report)}>
            View
        </Button>
    );
}